var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "175%",
    height: "175%",
    x: "-37.5%",
    y: "-37.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.231372549 0 0 0 0 0.454901961 0 0 0 0 0.658823529 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DCDFE5",
    d: "M22 16H2c-1.104 0-2-.896-2-2V2C0 .896.896 0 2 0h20c1.104 0 2 .896 2 2v12c0 1.104-.896 2-2 2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.5 8h-5c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5h5c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B8C7",
    d: "M5.711 13H2.288C2.13 13 2 12.871 2 12.711v-1.422c0-.16.13-.289.288-.289h3.423c.16 0 .29.129.29.289v1.422c0 .16-.13.289-.29.289M10.711 13H7.288C7.13 13 7 12.871 7 12.711v-1.422c0-.16.13-.289.288-.289h3.423c.16 0 .29.129.29.289v1.422c0 .16-.13.289-.29.289M15.71 13H12.29c-.16 0-.29-.129-.29-.289v-1.422c0-.16.13-.289.29-.289h3.422c.16 0 .289.129.289.289v1.422c0 .16-.13.289-.29.289M20.71 13H17.29c-.16 0-.29-.129-.29-.289v-1.422c0-.16.13-.289.29-.289h3.422c.16 0 .289.129.289.289v1.422c0 .16-.13.289-.29.289",
    transform: "translate(4 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownCard);
export default __webpack_public_path__ + "static/media/unknown-card.bb5f5701f939acf432291ac7fd881238.svg";
export { ForwardRef as ReactComponent };